import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { CLessonInCourse } from '../../../typings';

export interface PeriodLessonsResponse {
    offset: number;
    result: Record<string, CLessonInCourse>
}

export function getPeriodLessons(
    courseId: number,
    params: {
        dates: number[];
        offset?: number;
        limit?: number;
        timezone?: number;
    }
): Promise<PeriodLessonsResponse> {
    const { apiGetPeriodLessonsLite } = apiConfig.getStaticUrls();

    return getFetch(`${apiGetPeriodLessonsLite}${courseId}/`, {
        ...params,
        dates: params.dates.join(','),
    });
}
